import { jsxs as u, jsx as s } from "react/jsx-runtime";
import { RocheUIButton as D } from "../button/roche-button.js";
import { RocheUIButtonTarget as x, RocheUIButtonAlignment as A, RocheUIButtonAppearance as g } from "../button/roche-button-types.js";
import { RocheUIHeadline as U } from "../headline/roche-headline.js";
import C from "./roche-add-to-calendar.module.scss.js";
const a = (e) => e ? new Date(e).toISOString() : "", l = (e) => e.replace(/-|:|\.\d{3}/g, ""), y = ({
  heading: e,
  eventTitle: t,
  description: n,
  startDate: r,
  endDate: c,
  icsLabel: p,
  googleCalendarLabel: h,
  outlookOnlineLabel: f,
  onCalendarLinkClick: E
}) => {
  const R = a(r), i = a(c), d = l(a(r)), m = l(a(c)), I = [
    {
      title: t,
      text: p,
      href: `data:text/calendar,${encodeURIComponent(
        `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${t}
DESCRIPTION:${n}
DTSTART:${d}
DTEND:${m}
END:VEVENT
END:VCALENDAR`
      )}`,
      icon: "file"
    },
    {
      text: h,
      href: `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=${d}%2F${m}&text=${encodeURIComponent(
        t
      )}&details=${encodeURIComponent(n)}`,
      icon: "google-cal"
    },
    {
      text: f,
      href: `https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent&path=%2Fcalendar%2Faction%2Fcompose&startdt=${R}&enddt=${i}&subject=${t}&body=${n}`,
      icon: "outlook"
    }
  ];
  return /* @__PURE__ */ u("div", { className: C["roche-add-to-calendar"], children: [
    /* @__PURE__ */ s(U, { level: "6", semanticLevel: "2", headline: e }),
    I.map((o, N) => /* @__PURE__ */ s(
      D,
      {
        hasMarginTop: !1,
        appearance: g.SECONDARY,
        alignment: A.LEFT,
        download: o.title,
        text: o.text,
        visuallyHiddenText: t && `, ${t}`,
        href: o.href,
        leftIcon: o.icon,
        target: x.BLANK,
        onClick: ($) => E($, o.text, o.href)
      },
      N
    ))
  ] });
};
export {
  y as RocheUIAddToCalendar
};
